module.exports = __webpack_public_path__ + "static/media/brizantha-marandu.fcd37689.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brizantha-marandu.jpg
// module id = 90
// module chunks = 0